<panel>
  <menu always-visible>
    <menuitem *requiredCredential="productsAccessFullCredential" (click)="createList()">{{ 'product.variant-lists.context-menu.create' | translate }}</menuitem>
  </menu>
  <h1>{{ 'product.edit-variant-lists.header' | translate }}</h1>
  @if (!variantLists) {
    <skeletons [defaultSkeletons]="4" />
  }
  @if (variantLists) {
    <list-view>
      <header>{{ 'product.edit-variant-lists.list-name' | translate }}</header>
      <header>{{ 'product.edit-variant-lists.list-options-count' | translate }}</header>
      <row *listData="let list from variantLists" (action)="editList(list)">
        <column>{{ list.name }}</column>
        <column>{{ list.variantListOptions.length }}</column>
      </row>
    </list-view>
  }
</panel>
